import React, { useRef } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { RollingLoader } from "../../../commons";
import { BOMSavedTemplate } from "../../../../screens";

type AppProps = {
  showAddTemplateModal: boolean;
  toogleAddTemplateModal: () => void;
  handleUseTemplateId: any;
  templateFetching: boolean | undefined;
  history: any;
};

const BOMTemplateListModal = ({
  showAddTemplateModal,
  toogleAddTemplateModal,
  templateFetching,
  history,
  handleUseTemplateId,
}: AppProps) => {
  const scrollRef = useRef<any>("");

  return (
    <div>
      <Modal
        size="xl"
        isOpen={showAddTemplateModal}
        toggle={() => {
          toogleAddTemplateModal();
          history.goBack();
        }}
      >
        <ModalHeader
          toggle={() => {
            toogleAddTemplateModal();
            history.goBack();
          }}
          className="pt-4 pl-4"
        >
          Manufacturing Journal Template List
        </ModalHeader>
        <ModalBody className="pl-4 pr-4">
          <div ref={scrollRef} style={{ overflowY: "auto", height: "90vh" }}>
            <div>
              <BOMSavedTemplate
                type="template"
                handleUseTemplateId={handleUseTemplateId}
                scrollRef={scrollRef}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default BOMTemplateListModal;
